var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    viewBox: "0 0 220 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "logo-dark_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 220,
    height: 127
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.677.418H0v126.264h219.677V.418z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-dark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.672 29.556L105 71.254H60.908L46.316 91.535h103.029L88.827 8.086a17.485 17.485 0 00-28.31 0L0 91.535h29.974l44.698-61.979z",
    fill: "#505354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.316.418H85.948a21.233 21.233 0 015.861 5.507l11.587 15.977h79.46a12.445 12.445 0 0112.443 12.443 12.445 12.445 0 01-12.443 12.443H153.87l-16.122 22.483 15.714 21.668 17.064-23.8h15.79a33.36 33.36 0 100-66.723",
    fill: "#41ADCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.556 120.336h-8.041l-2.6 6.346H0l14.153-28.937h11.383l3.285 28.937H19.86l-.304-6.346zm-1.108-16.342l-4.8 10.712h5.764l-.771-10.712h-.193zM34.547 97.745h8.718l-3.716 20.518a1.429 1.429 0 001.357 1.718h9.619l-1.213 6.7H35.555a5.35 5.35 0 01-4.041-2.033 5.349 5.349 0 01-1.043-4.401l4.076-22.502zM55.762 97.745h8.719l-3.716 20.518a1.429 1.429 0 001.357 1.718h9.618l-1.213 6.7H56.77a5.35 5.35 0 01-4.04-2.033 5.349 5.349 0 01-1.044-4.401l4.076-22.502z",
    fill: "#505354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.112 98.355a6.218 6.218 0 013.807 2.919c.82 1.439.99 3.495.505 6.168a15.381 15.381 0 01-1.166 3.63 18.472 18.472 0 01-1.843 3.224 7.086 7.086 0 01-1.654 1.777 8.235 8.235 0 01-3.146.786c-1.834.2-3.679.294-5.524.28-.743 0-1.884-.033-3.42-.1l-1.748 9.645h-8.719l5.241-28.937c3.41-.1 7.132-.151 11.17-.152 2.19-.053 4.379.204 6.5.762m-4.267 9.645c.313-1.726.186-2.944-.379-3.655-.565-.711-1.704-1.066-3.416-1.067-.642.005-1.282.056-1.917.153l-1.4 7.717c.316.034.943.051 1.88.05 2.486 0 3.908-.186 4.267-.559a5.63 5.63 0 00.962-2.64M109.797 120.336h-8.041l-2.6 6.346h-8.913l14.153-28.937h11.383l3.285 28.937h-8.961l-.306-6.346zm-1.108-16.342l-4.8 10.712h5.764l-.773-10.712h-.191zM136.575 117.442l-1.674 9.239h-8.719l1.655-9.138-5.714-19.8h8.864l1.981 9.392c.215.948.39 1.948.523 3h.1a57.381 57.381 0 011.626-3.1l5.316-9.29h8.816l-12.774 19.697z",
    fill: "#41ADCE"
  }))));
}
export default SvgLogoDark;